// 搜尋用的名稱正規化：忽略大小寫、全形半形、™®©、標點與符號。

const TRADEMARKS = /[™®©℠]/g; // ™ ® © ℠
const APOSTROPHES = /['‘’ʼ`]/g; // Baldur's → baldurs
const PUNCT_OR_SYMBOL = /[\p{P}\p{S}]+/gu;
const SPACES = /\s+/g;

export function normalizeForSearch(s: string): string {
  return s
    .replace(TRADEMARKS, '') // 要在 NFKC 之前移除，否則 ™ 會被正規化成 "TM"
    .normalize('NFKC') // 全形→半形、相容字元統一
    .replace(APOSTROPHES, '')
    .toLowerCase()
    .replace(PUNCT_OR_SYMBOL, ' ')
    .replace(SPACES, ' ')
    .trim();
}

/**
 * 預先建立一款遊戲的搜尋字串（所有名稱正規化後，再附上去掉空白的版本），
 * 讓「spiderman」能找到「Spider-Man」。清單載入時算一次，篩選時只做字串比對。
 */
export function buildSearchText(...names: (string | null | undefined)[]): string {
  const parts = names.filter((n): n is string => !!n).map(normalizeForSearch);
  return [...parts, ...parts.map((p) => p.replaceAll(' ', ''))].join('|');
}

/** 查詢字串的每個詞都要出現在搜尋字串中（順序不拘）。 */
export function matchesQuery(searchText: string, query: string): boolean {
  const q = normalizeForSearch(query);
  if (!q) return true;
  return q.split(' ').every((token) => searchText.includes(token));
}
